import { render, staticRenderFns } from "./AnotacionComponent.vue?vue&type=template&id=57a819b8&scoped=true&"
import script from "./AnotacionComponent.vue?vue&type=script&lang=js&"
export * from "./AnotacionComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnotacionComponent.vue?vue&type=style&index=0&id=57a819b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a819b8",
  null
  
)

export default component.exports